import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import { FormsModule as CasFormsModule } from '@caslink/common-client/ng-app/forms/FormsModule';
import { LoadingAnimationModule } from '@caslink/common-client/ng-app/loadingAnimation/LoadingAnimationModule';
import { AppModule as CasCommonAppModule } from '@caslink/common-client/ng-app/module';
import { DeviceInputModule } from '../device-input/device-input.module';
import { RtuModalButtonsComponent } from '../rtu-modal-buttons/rtu-modal-buttons.component';
import { RtuSetpointEditorComponent } from './rtu-setpoint-editor.component';
import { RtuSetpointEditorPopupComponent } from '../rtu-setpoint-editor-popup/rtu-setpoint-editor-popup.component';

@NgModule({
    imports: [
        CommonModule,
        CasCommonAppModule,
        CasFormsModule,
        DeviceInputModule,
        LoadingAnimationModule,
        ReactiveFormsModule,
        MatDialogModule
    ],
    declarations: [
        RtuSetpointEditorComponent,
        RtuSetpointEditorPopupComponent,
        RtuModalButtonsComponent
    ],
    entryComponents: [
        RtuSetpointEditorComponent,
        RtuSetpointEditorPopupComponent
    ],
    exports: [
        RtuSetpointEditorComponent,
        RtuSetpointEditorPopupComponent
    ]
})
export class RtuSetpointEditorModule {
}
